'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ = require('../');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _classConcat = require('../../utils/classConcat');

var _classConcat2 = _interopRequireDefault(_classConcat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonGroup = function ButtonGroup(_ref) {
    var children = _ref.children,
        name = _ref.name,
        modifiers = _ref.modifiers,
        className = _ref.className;

    var buttonGroupClasses = (0, _classnames2.default)(['luna-buttonGroup', (0, _classConcat2.default)('luna-buttonGroup', modifiers), className]);
    return _react2.default.createElement("div", { className: buttonGroupClasses, role: 'group' }, _react2.default.Children.map(children, function (child) {
        return child.type === _.Button ? _react2.default.cloneElement(child, {
            name: name
        }) : child;
    }));
};
ButtonGroup.propTypes = {
    name: _propTypes2.default.string,
    modifiers: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]),
    className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.object])
};
exports.default = ButtonGroup;
//# sourceMappingURL=ButtonGroup.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/ButtonGroup/ButtonGroup.js